import { FaTools } from 'react-icons/fa';

const Maintenance = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
            {/* bouncing wrench icon */}
            <FaTools className="text-6xl text-indigo-600 animate-bounce mb-6" />

            {/* headline */}
            <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4 text-center">
                We&rsquo;ll be back&nbsp;soon!
            </h1>

            {/* sub‑text */}
            <p className="text-lg md:text-xl text-gray-600 text-center max-w-lg">
                Our site is currently undergoing scheduled maintenance.<br />
                Thanks for your patience — we&rsquo;ll be back online shortly.
            </p>
        </div>
    );
};

export default Maintenance;
